/**
 * アラートダイアログ
 *
 * @param {string} message - メッセージ
 * @param {string} close - 閉じるボタンのラベル
 * @returns {Promise<void>} モーダルが閉じたら解決
 */
window.showAlert = function (message, close = '') {
    return new Promise((resolve) => {
        const modalEl = document.getElementById('globalAlertModal');
        if (!modalEl) {
            resolve();
            return;
        }

        document.getElementById('globalAlertMessage').textContent = message;
        if (close) document.getElementById('globalAlertClose').textContent = close;

        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);

        function onHidden() {
            modalEl.removeEventListener('hidden.bs.modal', onHidden);
            resolve();
        }

        modalEl.addEventListener('hidden.bs.modal', onHidden);

        modal.show();
    });
};
